import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const DateTimeDisplay = () => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formatDay = (date: Date) => {
        return date.toLocaleDateString('en-US', { weekday: 'long' });
    };

    const formatDate = (date: Date) => {
        return date.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        });
    };

    const formatTime = (date: Date) => {
        return date.toLocaleTimeString('en-US', { 
            hour12: true, 
            hour: '2-digit', 
            minute: '2-digit', 
            second: '2-digit' 
        });
    };

    return (
        <div className="flex items-center gap-3 text-topbar-item group-data-[topbar=dark]:text-topbar-item-dark group-data-[topbar=brand]:text-topbar-item-brand">
            <Clock className="w-4 h-4" />
            <div className="flex items-center gap-2">
                <span className="text-sm font-medium">
                    {formatDay(currentTime)}
                </span>
                <span className="text-xs opacity-80">
                    {formatDate(currentTime)}
                </span>
                <span className="text-xs font-mono opacity-90">
                    {formatTime(currentTime)}
                </span>
            </div>
        </div>
    );
};

export default DateTimeDisplay;
